import { ReactElement, ReactNode } from 'react';

import { Portal } from '@dreryk/react-components';

import { StyledVisitHeaderActionsContainer } from './VisitHeaderActionsPortal.styled';

const VISIT_HEADER_ACTIONS_PORTAL_ID = 'visitHeaderActionsPortal';

type VisitHeaderActionsContainerProps = {
   readonly children?: ReactNode | ReactNode[];
};

export const VisitHeaderActionsContainer = (props: VisitHeaderActionsContainerProps): JSX.Element => (
   <StyledVisitHeaderActionsContainer id={VISIT_HEADER_ACTIONS_PORTAL_ID} testId={'visitHeaderActions'}>
      {props.children}
   </StyledVisitHeaderActionsContainer>
);

type VisitHeaderActionsPortalProps = {
   readonly children: ReactElement | ReactElement[];
};

const VisitHeaderActionsPortal = (props: VisitHeaderActionsPortalProps): JSX.Element => (
   <Portal containerId={VISIT_HEADER_ACTIONS_PORTAL_ID}>{props.children}</Portal>
);

export const VisitHeaderActions = {
   Portal: VisitHeaderActionsPortal,
   Container: VisitHeaderActionsContainer,
};
